<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    :title="title"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="addForm" :rules="addRules" ref="addForm">
      <el-form-item label="姓名" :label-width="formLabelWidth" prop="nickName">
        <el-input v-model="addForm.nickName" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="内部账号（工号）"
        :label-width="formLabelWidth"
        prop="mobile"
      >
        <el-input v-model="addForm.mobile" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="密码"
        v-if="title == '新增账号'"
        :label-width="formLabelWidth"
        prop="password"
      >
        <el-input v-model="addForm.password" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="身份"
        v-if="title == '新增账号'"
        :label-width="formLabelWidth"
        prop="roleId"
      >
        <el-select v-model="addForm.roleId" placeholder="请选择身份">
          <el-option
            v-for="item in rolesList"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitAdd('addForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { formData, formRules } from '../form.js'
import { addRolesApi, editAccountApi } from '@/api/user.js';
export default {
  name: 'AddAuth',
  data() {
    // var phoneValidate = (_, value, callback) => {
    //   const phoneReg =
    //     /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
    //   if (!phoneReg.test(value)) {
    //     return callback(new Error('手机号码格式有误！'));
    //   }
    //   callback();
    // };
    var pwdValidate = (_, value, callback) => {
      if (value.length <= 8) {
        return callback(new Error('密码长度必须大于8位'));
      }
      callback();
    };
    return {
      rolesList: [],
      formLabelWidth: '180px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      title: '',
      addForm: {
        // 编辑表单
        roleId: '',
        nickName: '',
        mobile: '',
        password: '',
      },
      addRules: {
        // 表单的验证规则
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        nickName: [
          { required: true, message: '名字不能为空', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          // { validator: phoneValidate, trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: pwdValidate, trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    // console.log('表单：', this.addForm);
  },
  methods: {
    submitAdd(formName) {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      this.$refs.addForm.validate(async (valid) => {
        if (!valid) return;
        if (this.title == '新增账号') {
          const res = await addRolesApi({ ...this.addForm, areaId });
          if (res.code !== 200) return this.$message.error(res.message);
          this.$message.success('新增成功!');
        } else {
          let { userId, nickName, mobile } = this.addForm;
          console.log('addForm', this.addForm);
          const res = await editAccountApi({ userId, nickName, mobile });
          if (res.code !== 200) return this.$message.error(res.message);
          this.$message.success('编辑成功!');
        }
        // 重新请求数据
        this.$emit('search');
        this.dialogFormVisible = false;
        // 清空表单
        this.$refs[formName].resetFields();

        // 重新获取数据
        // this.reload();
      });
    },
    // 关闭
    handleClose() {
      // 清空表单
      // this.$refs['addForm'].resetFields();
    },
  },
  created() {},
};
</script>

<style></style>
